import request from "./http";
import { TRANSACTIONAL_ENDPOINT } from "../infrastructure/appConstants";

const transactionalService = {
  afiliacionClaveSmsVerificacion: (req) =>
    request.post(`${TRANSACTIONAL_ENDPOINT}/afiliacion/verification`, req),
  afiliacionClaveSmsConfirmacion: (req) =>
    request.post(`${TRANSACTIONAL_ENDPOINT}/afiliacion/confirmation`, req),
  afiliacionClaveSmsCancelar: () =>
    request.post(`${TRANSACTIONAL_ENDPOINT}/afiliacion/cancelar`),
  listarClaveDobleFactor: () =>
    request.get(`${TRANSACTIONAL_ENDPOINT}/clave-doble-factor/listar`),
  generarClaveDobleFactor: (req) =>
    request.post(`${TRANSACTIONAL_ENDPOINT}/clave-doble-factor/generar`, req),
  validarClaveDobleFactor: (req) =>
    request.post(`${TRANSACTIONAL_ENDPOINT}/clave-doble-factor/validar`, req),
};

export default transactionalService;
